import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container } from '@mui/material';
import ThemeProvider from '../theme';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../assets/contexts/userContext';
import usePageBackground from "../hooks/usePageBackground";
import { useFadeInOnScroll } from "../theme/global";
import '../css/global.css';

const StyledContent = styled('div')(({ theme }) => ({
maxWidth: 680,
  margin: 'auto',
  minHeight: '80vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: theme.spacing(0),
  gap: theme.spacing(4),
}));

export default function ErrorPage() {
  const { user } = useContext(UserContext);
  const isAdmin = user.hasRole('admin');
  const navigate = useNavigate();

  usePageBackground('page-404');
  const containerRef = useFadeInOnScroll();

  const handleClick = () => {
    if (user.isLogged) {
      navigate(isAdmin ? '/admin/adminDashboard' : '/employee/employeeDashboard');
    } else {
      navigate('/');
    }
  };

  return (
    <>
      <ThemeProvider>
        <Helmet>
          <title>Error | CES</title>
          <meta name="description" content="Ha ocurrido un error al cargar los datos." />
        </Helmet>
        <Container ref={containerRef} className="fade-up" sx={{ p: 2 , }}>
          <StyledContent >
            <Typography variant='h4' sx={{ color: 'text.secondary', fontWeight: 'fontWeightBold' }}>
              Lo sentimos, ha habido un error al cargar la información solicitada.
            </Typography>
            <Button size="large" variant="contained" onClick={handleClick}>
              {user.isLogged ? 'Ir al panel principal' : 'Volver a inicio'}
            </Button>
          </StyledContent>
        </Container>
      </ThemeProvider>
    </>
  );
}
